import React from 'react';

const About = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <section className="mb-12">
        <h1 className="text-4xl font-bold text-center mb-6">
          Hakkımızda
        </h1>
        <div className="max-w-3xl mx-auto">
          <p className="text-lg text-gray-600 mb-6">
            Biz, 2020 yılından bu yana dijital dünyada hizmet veren bir teknoloji şirketiyiz.
            Müşterilerimizin ihtiyaçlarına özel çözümler geliştirerek, onların dijital
            dönüşüm süreçlerine katkıda bulunuyoruz.
          </p>
          <p className="text-lg text-gray-600 mb-6">
            Deneyimli ekibimiz, modern teknolojileri kullanarak yenilikçi çözümler
            üretmektedir. Web tasarım, mobil uygulama geliştirme ve dijital pazarlama
            alanlarında uzmanlaşmış kadromuzla hizmet vermekteyiz.
          </p>
          <p className="text-lg text-gray-600">
            Misyonumuz, müşterilerimizin dijital varlıklarını güçlendirmek ve
            sürdürülebilir başarı elde etmelerini sağlamaktır.
          </p>
        </div>
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Misyonumuz</h2>
          <p className="text-gray-600">
            Müşterilerimizin dijital dönüşüm süreçlerinde yanlarında olmak ve
            onlara en iyi hizmeti sunmak için çalışıyoruz.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Vizyonumuz</h2>
          <p className="text-gray-600">
            Dijital dünyada öncü ve yenilikçi çözümler sunan, güvenilir bir
            teknoloji partneri olmak.
          </p>
        </div>
      </section>
    </div>
  );
};

export default About; 